import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Button } from 'primereact/button';
import { Link } from 'react-router-dom';
import { resetSurveyRespondentStatus } from '../../../../graphql/survey/Mutation';
import { growlErrors } from '../../../../utils/NotificationUtil';
import { ConfirmModal } from '../../../../components/modal/ActionModal';
import { growlShape } from '../../../../components/prop-types';
import { withGrowl } from '../../../../components/GrowlNotifications';

const getItemStatus = {
  NEW: (
    <FormattedMessage id="candidate.status.NEW" defaultMessage="NEW">
      {text => <span className="filter is-active">{text}</span>}
    </FormattedMessage>
  ),
  INVITED: (
    <FormattedMessage id="candidate.status.INVITED" defaultMessage="INVITED">
      {text => <span className="filter filter--info is-active">{text}</span>}
    </FormattedMessage>
  ),
  STARTED: (
    <FormattedMessage id="candidate.status.STARTED" defaultMessage="IN PROGRESS">
      {text => <span className="filter filter--warning is-active">{text}</span>}
    </FormattedMessage>
  ),
  DECLINED: (
    <FormattedMessage id="candidate.status.DECLINED" defaultMessage="DECLINED">
      {text => <span className="filter filter--error is-active">{text}</span>}
    </FormattedMessage>
  ),
  EXPIRED: (
    <FormattedMessage id="candidate.status.EXPIRED" defaultMessage="EXPIRED">
      {text => <span className="filter filter--error is-active">{text}</span>}
    </FormattedMessage>
  ),
  SUBMITTED: (
    <FormattedMessage id="candidate.status.SUBMITTED" defaultMessage="ASSESSED">
      {text => <span className="filter filter--success is-active">{text}</span>}
    </FormattedMessage>
  ),
};

class NewSurveyRespondentCard extends Component {
  constructor() {
    super();
    this.resetStatusDecline = this.resetStatusDecline.bind(this);
    this.rejectResetStatus = this.rejectResetStatus.bind(this);
    this.acceptResetStatus = this.acceptResetStatus.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.previewSurvey = this.previewSurvey.bind(this);
    this.handlePreviewInviteEmail = this.handlePreviewInviteEmail.bind(this);
    this.handlePreviewRemindEmail = this.handlePreviewRemindEmail.bind(this);
    this.state = {
      isResetStatusDecline: false,
    };
  }

  resetStatusDecline() {
    this.setState({
      isResetStatusDecline: true,
    });
  }

  rejectResetStatus() {
    this.setState({
      isResetStatusDecline: false,
    });
  }

  async acceptResetStatus() {
    const { assessment, currentAccount, growl } = this.props;
    const { id } = assessment;
    try {
      this.setState({
        isResetStatusDecline: false,
      });
      await resetSurveyRespondentStatus({
        surveyRespondentId: id,
        accountId: currentAccount,
      });
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  isSelected(category) {
    const { type } = this.props;
    return type === category;
  }

  async previewSurvey() {
    const { assessment } = this.props;
    window.open(assessment.startUrl, '_blank');
  }

  handlePreviewInviteEmail() {
    const { assessment } = this.props;
    window.open(assessment.previewInviteUrl, '_blank');
  }

  handlePreviewRemindEmail() {
    const { assessment } = this.props;
    window.open(assessment.previewReminderUrl, '_blank');
  }

  render() {
    const {
      onRemove,
      currentAccount,
      assessment,
    } = this.props;
    // TODO: fix this
    const { id: asmtId, status: asmtStatus, respondent } = assessment;
    const detailURL = `/accounts/${currentAccount}/surveys/${asmtId}/`;
    if (!respondent) return null;
    const assessmentStatus = asmtStatus || 'NEW';
    const { isResetStatusDecline } = this.state;
    const safeStatus = `${assessmentStatus}` === '' ? 'unknown' : assessmentStatus.toLowerCase();

    return (
      <div className="p-grid p-nogutter vertical-padding border-bottom">
        <div className="p-col-8">
          <div className="survey-respondent">
            <Link to={detailURL} className="survey-respondent-name">
              <div data-t="cs-item-name" className="">
                {`${respondent.firstName} ${respondent.lastName}`}
                {' '}
              </div>
            </Link>
            <div className="survey-respondent-email">{respondent.email}</div>
          </div>
        </div>
        <div className="p-col-4 align-right">
          <div className={`assessment assessment-${safeStatus}`}>{getItemStatus[assessmentStatus]}</div>

          <div className="">
            <Button
              type="button"
              className="p-button-secondary"
              icon="fa fa-trash"
              onClick={() => onRemove(respondent.id)}
            />
          </div>
          <ConfirmModal
            modalOpen={isResetStatusDecline}
            reject={this.rejectResetStatus}
            confirm={this.acceptResetStatus}
            typeButton="btn-primary"
          >
            <FormattedMessage
              id="mes.cofirm_reset_status"
              defaultMessage={'Clicking OK will reset the status to "INVITED".'}
            >
              {text => <p className="sentence-capitalized">{text}</p>}
            </FormattedMessage>
          </ConfirmModal>
        </div>
      </div>
    );
  }
}

NewSurveyRespondentCard.propTypes = {
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  onRemove: PropTypes.func,
  type: PropTypes.string.isRequired,
  currentAccount: PropTypes.string.isRequired,
  growl: growlShape.isRequired,
};

NewSurveyRespondentCard.defaultProps = {
  onRemove: null,
};

export default withGrowl(
  injectIntl(NewSurveyRespondentCard),
);
